import { render, staticRenderFns } from "./FoldersDraggable.vue?vue&type=template&id=7a65f440"
import script from "./FoldersDraggable.vue?vue&type=script&lang=js"
export * from "./FoldersDraggable.vue?vue&type=script&lang=js"
import style0 from "./FoldersDraggable.vue?vue&type=style&index=0&id=7a65f440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports